module.exports = __webpack_public_path__ + "img/paigangbang_touxian.5a07e778.png";